import { RouteProvider } from "views/components/Provider";
import { pathOr } from "ramda";
import { produce } from "immer";
import { useUpdateUserInfo } from "state/users/hooks";
import React, { useDispatch, useEffect, useGlobal, useState } from "reactn";
import format, { validate } from "lib/rut";

const validateRut = (v = "") => validate(v) && v.length > 5;

const ProfileScreen = ({ children, history }) => {
	const logout = useDispatch("logout");
	const [user] = useGlobal("user");
	const [userId, setUserId] = useState("");
	const [isPhoneValid, setIsPhoneValid] = useState(false);
	const { rut, dni, name, phone } = user;
	const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

	const whatsapp = pathOr(false, ["notifications", "whatsapp"], user);
	const push = pathOr(false, ["notifications", "push"], user);

	const [update, loading, error, resolved] = useUpdateUserInfo();

	const [countryCode, shortPhone] =
		phone && phone.length > 3
			? [phone.slice(0, 3), phone.slice(3)]
			: ["+56", ""];

	const [inputs, setInputs] = useState({
		rut,
		dni,
		type: "rut",
		name,
		phone: shortPhone,
		whatsapp,
		countryCode,
		push,
	});

	const checkSubmitDisabled = () => {
		const rutCheck = inputs.rut !== rut && validateRut(inputs.rut);
		const dniCheck = inputs.dni !== dni && inputs.dni > 3;
		const nameCheck = inputs.name !== name && inputs.name > 3;
		const phoneCheck = inputs.phone !== phone && isPhoneValid;
		const countryCheck = inputs.countryCode !== countryCode;

		const isChanged =
			rutCheck || dniCheck || nameCheck || phoneCheck || countryCheck;

		return !isChanged;
	};

	useEffect(() => {
		setIsSubmitDisabled(checkSubmitDisabled());
	}, [inputs]);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "rut" && value.length > 10) return null;
		setInputs((i) => ({ ...i, [name]: value }));
	};

	const handlePhoneChange = (phone, country) => {
		setInputs((i) => ({
			...i,
			phone,
			countryCode: `+${country.dialCode}`,
		}));
	};

	const onLogout = () => {
		logout().then(() => history.push("/welcome"));
	};

	const updateUserInfo = (_) => {
		const i = produce(inputs, (i) => {
			if (i.rut !== rut) {
				i.dni = null;
			} else if (i.dni !== dni) {
				i.rut = null;
			}

			if (i.phone === "null") {
				i.phone = "+56";
				return;
			}

			i.phone = i.countryCode + i.phone;
		});

		update(i);
	};
	useEffect(() => {
		setUserId(JSON.stringify(user.user_id));
	}, [user]);

	return children({
		userId,
		push,
		whatsapp,
		handleChange,
		inputs,
		setInputs,
		onLogout,
		loading,
		error,
		resolved,
		updateUserInfo,
		history,
		handlePhoneChange,
		isPhoneValid,
		setIsPhoneValid,
		isSubmitDisabled,
	});
};

export default RouteProvider(ProfileScreen);
